<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-29 14:59:20
 * @FilePath: /wemeet-admin-new/src/views/aiProduct/components/editAbstract.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <div class="demo-drawer__footer">
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </div>
    <el-descriptions border :column="1" direction="vertical" :size="desSize">
      <el-descriptions-item label="摘要">
        <el-input v-model="content" :autosize="{ minRows: 20, maxRows: 30 }" placeholder="" type="textarea" />
      </el-descriptions-item>
    </el-descriptions>
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { baseH5URL } from '@/config'
  import { abstractGetSummary, abstractUpdateSummary } from '@/api/ai'
  import { parseTime } from '@/utils/index'
  import { parse } from 'qs'
  export default defineComponent({
    name: 'EditAbstract',
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '40%',
        title: '链接地址',
        loading: null,
        row: {},
        registerMobileUrl: [],
        title: '编辑摘要',
        total: 0,
        layout: 'total, sizes, prev, pager, next, jumper',
        queryForm: {
          scheduleCode: '',
        },
        content: '',
      })
      // 打开
      const handleOpen = (row = {}) => {
        state.row = row
        state.queryForm.scheduleCode = row.scheduleCode
        getList()
        state.dialogFormVisible = true
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
      }

      const getList = async () => {
        const { data } = await abstractGetSummary(state.queryForm)
        console.log(data)
        state.content = data
      }
      const handleSave = async () => {
        try {
          const { data } = await abstractUpdateSummary({
            value: state.content,
            scheduleCode: state.queryForm.scheduleCode,
          })
          proxy.$baseMessage(`操作成功`, 'success', `vab-hey-message-success`)
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }

        handleClose()
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleSave,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    display: flex;
    margin-bottom: 5px;
  }
</style>
